(ns common.themes.capman)

(def border-radiuses
  {})

(def border-widths
  {})

(def palette
  "Palette of colors for this theme."
  {:background        "#F0EEEA"
   ;; Brand colors
   :brand-1           "#86E5D4"
   :brand-2           "#21948E"
   :brand-3           "#C5CFFD"

   ;; Gray scales
   :black             "#000000"
   :black-transparent "rgba(0,0,0,0.95)"
   :grey-80           "#242020"                                                                     ;; Black
   :grey-60           "rgba(36,32,32,.7)"                                                           ;; Gray
   :grey-50           "#888C81"                                                                     ;; Light grey
   :grey-40           "#F0F4F1"                                                                     ;; Lighter grey
   :grey-30           "#D9D9DA"                                                                     ;; Off gray
   :grey-25           "#EAEAEA"
   :grey-20           "rgba(0,0,0,.15)"                                                             ;; Off-white
   :grey-15           "rgba(240,238,234,0.35)"
   :grey-10           "rgba(36,32,32,0.10)"                                                         ;;Border-color
   :light-grey        "#FAF8F5"
   :grey-header       "#6C6A67"
   :grey-line         "#D7D7D7"
   :white             "#FFFFFF"                                                                     ;; Pure white
   ;; Complementary colors
   :info              "#3A32A7"                                                                     ;; Blue
   :success           "#8ABF4C"                                                                     ;; Success
   :warning           "#F7AC6A"                                                                     ;; Orange
   :danger            "#FC7171"                                                                     ;; Red
   :light             "#F2F2EE"
   :dark              "#32332F"
   ;;
   :transparent       "transparent"

   ;;  :capman-green "#1bc9b9"
   ;;  :capman-brown "#c38573"
   ;;  :capman-grey "#e1ddd5"
   ;;  :capman-grey-dark "#b5bbc2"
   ;;  :capman-green-dark "#1c9489"
   ;;  :capman-brown-dark "#845244"
   ;;  :capman-grey-tint "#c3beb7"
   ;;  :capman-dark "#83898f"
   ;;  :capman-green-light "#7ae6d8"
   ;;  :capman-brown-light "#f0baab"
   ;;  :capman-grey-light "#e1ddd5"


   :grey-border       "#E8E7E5"

   :border-color      "#EEEAE3"

   ;;  :custom-green-80 "#015757"
   ;;  :custom-green-60 "#1c9489"
   ;;  :custom-green-40 "#1bc9b9"
   ;;  :custom-green-20 "#7ae6d8"
   ;;  :custom-warm-grey-80 "#8E8A83"
   ;;  :custom-warm-grey-60 "#c3beb7"
   ;;  :custom-warm-grey-40 "#e1ddd5"
   ;;  :custom-warm-grey-20 "#f1eeea"
   ;;  :custom-cool-grey-20 "#d5dbe2"
   ;;  :custom-cool-grey-30 "#b5bbc2"
   ;;  :custom-cool-grey-60 "#83898f"
   ;;  :custom-cool-grey-90 "#363636"
   ;;  :custom-secondary-grey-80 "#253e50"
   ;;  :custom-secondary-grey-60 "#49667A"
   ;;  :custom-secondary-grey-40 "#66879d"
   ;;  :custom-secondary-grey-20 "#9db9cc"
   ;;  :custom-grey-10 "#DEDDDC"
   ;;  :custom-map-blue-dark "#6592c5"
   ;;  :custom-map-blue-light "#9ac0ec"

   :page-background   "#F7F6F3"

   ;; Brand colors
   :base-brand-1      "#1AC9B9"
   :base-brand-2      "#005757"
   :base-brand-3      "#9CABFF"
   :base-brand-4      "#6067E8"
   :base-brand-5      "#3A32A7"
   ;; TODO move these under `:custom`

   ;; Complementary colors

   :custom-colors     ["#86E5D4" "#21948E" "#C5CFFD" "#6067E8" "#005757" "#1AC9B9" "#9CABFF" "#6067E8"]
   :resi-custom-colors     ["#21948E" "#F7AC64" "#FC7171" "#6067E8" "#005757" "#1AC9B9" "#9CABFF" "#6067E8"]
   })

(def colors
  {:burger-menu      {:bg         :brand-1
                      :cross      :grey-80
                      :menu       {:bg :white}
                      :item       {:link   :grey-80
                                   :border :light-grey}
                      :link       {:color :grey-80}
                      :link-hover {:color :base-brand-1}}

   :link             {:primary   {:color :brand-3
                                  :hover :base-brand-2}
                      :secondary {:color       :grey-80
                                  :match       :warning
                                  :hover-color :white}
                      :main      {:color :brand-2}
                      :footer    {:color :white
                                  :hover :brand-1}
                      :border    {:color :custom-cool-grey-30}}

   :text-strong      {:primary   {:color :grey-80}
                      :hover     {:color :brand-2}
                      :secondary {:color :brand-3}}

   :text             {:primary   {:color :grey-80}
                      :secondary {:color :grey-60}
                      :main      {:color :black}}

   :menu-item        {:primary {:bg :brand-1}}

   :dropdown         {:bg    :white
                      :color :black
                      :hover {:color :black
                              :bg    :grey-40}
                      :focus {:color :black
                              :bg    :grey-40}}

   :layout           {:col     {:right-border :grey-30}
                      :primary {:bg :light-grey}}
   :general-border   {:border          :grey-15
                      :border-strong   :grey-15
                      :border-hover    :brand-1
                      :border-selected :brand-1
                      :caret           :grey-80}

   :figure           {:primary {:color :black}}

   :upload-file      {:primary {:color :grey-50}}

   :tablebg          {:primary {:bg :white}}

   :page-bg          {:bg :white}

   :outer-container  {:primary   {:bg :light-grey}
                      :secondary {:bg :white}
                      :border    :border-color}

   :entity-row       {:bg        :white
                      :border    :grey-30
                      :row       {:bg :transparent}
                      :sort-item {:border :grey-10}}

   :container-bgr    {:primary   {:bg :white}
                      :secondary {:bg :light-grey}
                      :helper    {:bg :brand-3}}                                                    ;; What ??

   :footer-bgr       {:secondary  {:bg :black}
                      :separator  :white
                      :text-hover :grey-50
                      :text       :white}

   :header-bgr       {:primary   {:bg    :black
                                  :color :white}
                      :secondary {:bg    :black
                                  :color :white}}

   ;;PORTAL styles

   :sidebar-nav-link {:regular {:color  :grey-80
                                :bg     :white
                                :border :transparent}
                      :hover   {:color  :brand-2
                                :bg     :white
                                :border :brand-2}}

   :home-link        {:regular {:color  :grey-80
                                :hover  :brand-2
                                :bg     :white
                                :border :custom-warm-grey-40}
                      :back    {:hover   :grey-80
                                :default :grey-80}
                      :hover   {:color :brand-2}}

   ;;Editor styles

   :icon-step        {:regular {:color :grey-80}
                      :done    {:color :brand-2}}

   :progress         {:default    {:bg :grey-30}
                      :active     {:bg :brand-3}
                      :activeText {:color :white}}

   :badge            {:primary   {:bg :brand-1
                                  :fg :white}
                      :secondary {:bg :grey-60
                                  :fg :white}
                      :success   {:bg :success
                                  :fg :white}
                      :danger    {:bg :danger
                                  :fg :white}
                      :warning   {:bg :warning
                                  :fg :black}
                      :info      {:bg :info
                                  :fg :white}
                      :light     {:bg :light
                                  :fg :black}
                      :dark      {:bg :dark
                                  :fg :white}}
   :breadcrumb       {:link       :brand-1
                      :link-hover :brand-1}

   :button           {:disabled   {:link  {:bg :white
                                           :fg :grey-40}
                                   :other {:bg :grey-40
                                           :fg :white}}
                      :focus      {:other {:border :white}}
                      :regular    {:primary   {:bg :background
                                               :fg :black}
                                   :secondary {:bg :grey-60
                                               :fg :white}
                                   :success   {:bg :success
                                               :fg :white}
                                   :danger    {:bg :danger
                                               :fg :white}
                                   :warning   {:bg :warning
                                               :fg :white}
                                   :info      {:bg :info
                                               :fg :white}
                                   :light     {:bg :light
                                               :fg :black}
                                   :dark      {:bg :dark
                                               :fg :white}
                                   :link      {:bg :white
                                               :fg :blue-link}
                                   :frame     {:bg :white
                                               :fg :custom-green-80}}
                      :nav-button {:bg        :light-grey
                                   :color     :grey-80
                                   :secondary {:bg    :transparent
                                               :color :brand-2}}}

   :card             {:card {:box-shadow :grey-30
                             :bg         :background}
                      :head {:disabled :grey-30
                             :title    :grey-80}
                      :body {:border-top :grey-20
                             :border     :grey-15
                             :bg         :white
                             :link       {:regular :brand-2
                                          :hover   :base-brand-2}}}

   :content-card     {:body  {:bg     :white
                              :border :grey-20}
                      :row   {:border :grey-20}
                      :child {:primary   {:bg :white}
                              :secondary {:bg :grey-15}}
                      :title {:color :grey-80}}

   :checkbox         {:regular-label {:disabled :grey-20}
                      :custom-label  {:enabled  {:bg {:checked   :brand-2
                                                      :unchecked :grey-20}
                                                 :fg :black}
                                      :disabled {:bg :grey-30
                                                 :fg :black}}
                      :custom-handle {:bg :white}
                      :regular-icon  {:disabled {:fg :grey-30}
                                      :checked  {:fg :brand-1}
                                      :fg       :grey-30}
                      :text          {:custom {:fg :white}}}
   :file-input       {:file-status            {:bg :white}
                      :file-name              :grey-80
                      :progress-bar-container {:bg :grey-30
                                               :fg :grey-40}
                      :progress-bar           {:bg :brand-1}
                      :file-input             {:fg     :grey-80
                                               :bg     :white
                                               :border :background}
                      :file-input-icon        {:fg :grey-30}
                      :file-remove            {:fg    :grey-80
                                               :hover {:fg :danger}}}

   :text-input       {:border     {:regular :grey-30
                                   :hover   :grey-80
                                   :focus   :grey-80}
                      :background {:disabled :light-grey}
                      :bg         :background}
   :sub-header       {:border     :background
                      :text       :black
                      :title      :black
                      :long-title :black}
   :field-options    {:color  :black
                      :bg     :white
                      :item   {:bg     :white
                               :color  :black
                               :border :grey-30}
                      :header {:border :grey-30}}

   :modal-dialog     {:header        {:bg            :white
                                      :text          :grey-80
                                      :border-bottom :grey-15
                                      :color         :grey-80}
                      :footer        {:border-top :grey-15}
                      :modal         :black
                      :modal-content {:bg :white}}
   :radio-group      {:icon {:checked   :brand-1
                             :unchecked :grey-30}}
   :rich-text-editor {:wrapper {:border :grey-30}
                      :toolbar {:border-bottom :grey-30}}
   :search-input     {:border {:regular :grey-30
                               :hover   :grey-80
                               :focus   :grey-80}}
   :select-input     {:container           {:bg     :white
                                            :border :grey-30}
                      :input-container     {:bg :grey-15}
                      :group-heading       {:bg :grey-30}
                      :indicator-separator :grey-30
                      :loading-indicator   :grey-30
                      :loading-message     :grey-30
                      :menu                :white
                      :multi-value         {:border :grey-20
                                            :fg     :grey-80}
                      :no-options-message  {:border :grey-30}
                      :option              {:selected   {:border-top :grey-15
                                                         :bg         :white
                                                         :fg         :grey-80
                                                         :hover      {:bg :base-brand-2
                                                                      :fg :white}}

                                            :focused    {:border-top :grey-80
                                                         :bg         :base-brand-2
                                                         :fg         :white}
                                            :border-top :grey-20}
                      :placeholder         {:fg :grey-50}
                      :deselect-button     {:bg :grey-25}}
   :sortable-list    {:drag-handle {:bg     :white
                                    :border :grey-30}}
   :steps-band       {:steps-band {:border :transparent}
                      :step       {:fg          {:completed        :white
                                                 :completed-active :white
                                                 :active           :white
                                                 :next             :grey-80}
                                   :bg          {:completed        :grey-80
                                                 :completed-active :brand-2
                                                 :active           :brand-2
                                                 :next             :white}
                                   :border-left {:before :grey-30
                                                 :after  {:completed        :grey-80
                                                          :completed-active :brand-2
                                                          :active           :brand-2
                                                          :next             :white}}}
                      :step-icon  {:completed        {:bg :transparent
                                                      :fg :white}
                                   :completed-active {:bg :transparent
                                                      :fg :white}
                                   :active           {:bg :transparent
                                                      :fg :grey-80}
                                   :next             {:bg :transparent
                                                      :fg :grey-80}}}
   :tab-layout       {:tab-title  {:regular  {:border-bottom :grey-10}
                                   :selected {:fg            :brand-2
                                              :border-bottom :brand-2}
                                   :text     {:default  :gray-80
                                              :selected :brand-2}
                                   :border   {:default  :transparent
                                              :selected :brand-2}}
                      :title-line {:border :transparent}}

   :dynamic-table    {:border      :background
                      :heading     {:border :background}
                      :cell        {:border :background}
                      :title-cell  {:border :background}
                      :text        {:color :black}
                      :total       {:bg     :white
                                    :fg     :black
                                    :border :grey-80}
                      :sub-total   {:bg :background}
                      :blank       {:border :light-grey}
                      :th          {:border :grey-80}
                      :bg          :grey-40
                      :heading-row {:bg :base-brand-1}                                              ;; TODO: resolve this correctly from master
                      :odd-row     {:bg :white}
                      :even-row    {:bg :light-grey}}

   :news-section     {:general         {:bg    :brand-1
                                        :color :black}
                      :dropdown        {:color      :black
                                        :background :transparent
                                        :border     :black
                                        :outline    :brand-3}
                      :dropdown-option {:color :grey-20}
                      :show-all        {:default {:color :black}
                                        :hover   {:color :brand-2}}}

   :table            {:border :grey-30
                      :tr     {:even            :light-grey
                               :odd             :white
                               :subheading      :grey-80
                               :subheading-text :white}
                      :th     {:bg            :background
                               :fg            :black
                               :border-bottom :background}}
   :chart            {:waterfall     {:line  :brand-1
                                      :start :brand-2
                                      :sum   :brand-3
                                      :up    :base-brand-2
                                      :down  :danger
                                      :color :brand-1}
                      :x-axis        {:line      :light-grey
                                      :grid-line :light-grey}
                      :y-axis        {:line      :light-grey
                                      :grid-line :light-grey}
                      :line-chart    {:line            :brand-1
                                      :multi-primary   :brand-2
                                      :multi-secondary :brand-3}
                      :bar-chart     {:primary   :brand-1
                                      :secondary :brand-3
                                      :grid      {:line :background}}
                      :locations-map {:marker {:bg   :white
                                               :line :brand-3}}}
   :pdf              {:table        {:odd-color     :light-grey
                                     :even-color    :white
                                     :heading-color :grey-80
                                     :header-border :background
                                     :border        :background
                                     :raw-border    :background
                                     :total-border  :background
                                     :heading       {:text :white}
                                     :text          :grey-80}
                      :stack        {:label      :grey-80
                                     :value      :grey-80
                                     :value-list :grey-80}
                      :color        :grey-80
                      :footer       {:text :black}
                      :color-dark   :grey-80
                      :heading      :grey-80
                      :page-heading :grey-80
                      :border       :grey-15
                      :landing-page {:text :white}
                      :toc          {:text :grey-80}
                      :column       {:color :grey-80}
                      :fill         :white
                      :text         {:h1   :grey-80
                                     :h2   :grey-80
                                     :h3   :grey-80
                                     :a    :grey-80
                                     :html :grey-80}}
   :lp-report        {:big-figures      {:pdf {:border :grey-15
                                               :value  :black
                                               :label  :grey-80}}
                      :chart            {:x-axis      {:line      :grey-line
                                                       :grid-line :grey-line}
                                         :y-axis      {:line      :grey-line
                                                       :grid-line :grey-line}
                                         :map-locations {:country {:gradient-start :brand-1
                                                                   :gradient-end   :brand-2}}
                                         :bar           {:gradient-start :brand-1
                                                         :gradient-end   :brand-3}
                                         :column        {:default        :brand-1
                                                         :gradient-start :brand-2
                                                         :gradient-end   :brand-3}
                                         :waterfall     {:gradient-start :brand-1
                                                         :gradient-end   :brand-2}
                                         :multi-bar     {:gradient-start :brand-1
                                                         :gradient-end   :brand-2}
                                         :multi-chart   {:ordered-default-colors {:color-1 :brand-1
                                                                                  :color-2 :brand-2
                                                                                  :color-3 :brand-3
                                                                                  :color-4 :base-brand-1
                                                                                  :color-5 :base-brand-2
                                                                                  :color-6 :base-brand-3}}
                                         :donut         {:gradient-start :base-brand-1
                                                         :gradient-end   :base-brand-3}
                                         :bar-1         :base-brand-1
                                         :bar-2         :base-brand-2
                                         :line-1        :base-brand-4
                                         :line-2        :base-brand-5
                                         :map           {:highlighted-countries     {:color :brand-1}
                                                         :non-highlighted-countries {:color :brand-2}
                                                         :hover                     {:color :base-brand-2}
                                                         :label                     {:color :white}}}
                      :table            {:font-color         :grey-80
                                         :even-row           {:bg :light-grey}
                                         :odd-row            {:bg :white}
                                         :heading-color      {:bg :background
                                                              :fg :black}
                                         :heading-info-color {:bg :background}
                                         :subheading-color   {:bg :background}
                                         :subtotal-color     {:bg :background}
                                         :total-color        {:bg :background}
                                         :empty-line-color   {:bg :white}
                                         :pdf                {:even-row           {:bg :white}
                                                              :odd-row            {:bg :light-grey}
                                                              :heading-color      {:bg :background
                                                                                   :fg :black}
                                                              :heading-info-color {:bg :background
                                                                                   :fg :black}
                                                              :subheading-color   {:bg :background
                                                                                   :fg :black}
                                                              :subtotal-color     {:bg :white}
                                                              :total-color        {:bg :white}
                                                              :empty-line-color   {:bg :white}
                                                              :heading-border     :background}}
                      :horizontal-table {:heading  {:background :white}
                                         :even-row {:bg :white}
                                         :odd-row  {:bg :light-grey}
                                         :pdf      {:even-row           {:bg :white}
                                                    :odd-row            {:bg :light-grey}
                                                    :heading-color      {:bg :light-grey}
                                                    :heading-info-color {:bg :light-grey}
                                                    :subheading-color   {:bg :white}
                                                    :subtotal-color     {:bg :white}
                                                    :total-color        {:bg :white}
                                                    :empty-line-color   {:bg :white}}}
                      :vertical-table   {:even-row {:bg :white}
                                         :odd-row  {:bg :light-grey}
                                         :pdf      {:even-row           {:bg :white}
                                                    :odd-row            {:bg :light-grey}
                                                    :heading-color      {:bg :light-grey}
                                                    :heading-info-color {:bg :light-grey}
                                                    :subheading-color   {:bg :white}
                                                    :subtotal-color     {:bg :white}
                                                    :total-color        {:bg :white}
                                                    :empty-line-color   {:bg :white}}}
                      :block-table      {:even-row {:bg :white}
                                         :odd-row  {:bg :grey-20}
                                         :pdf      {:even-row           {:bg :white}
                                                    :odd-row            {:bg :light-grey}
                                                    :heading-color      {:bg :light-grey}
                                                    :heading-info-color {:bg :light-grey}
                                                    :subheading-color   {:bg :white}
                                                    :subtotal-color     {:bg :white}
                                                    :total-color        {:bg :white}
                                                    :empty-line-color   {:bg :white}}}
                      :report-row       {:border       :grey-15
                                         :border-hover :grey-80
                                         :default      :grey-80}
                      :section          {:border  :grey-20
                                         :default :grey-80}}
   :lp-portal        {:dashboard        {:pie-colors [:brand-1
                                                      :brand-2
                                                      :brand-3
                                                      :base-brand-1
                                                      :base-brand-2
                                                      :base-brand-3
                                                      :base-brand-4
                                                      :brand-1
                                                      :brand-2
                                                      :brand-3
                                                      :base-brand-1
                                                      :info
                                                      :black]}
                      :clickable        {:text {:default :brand-2
                                                :hover   :base-brand-2}}
                      :carousel         {:dot {:default {:border     :grey-80
                                                         :background :white}
                                               :hover   {:border     :brand-2
                                                         :background :white}}}
                      :promotion        {:text         :grey-80
                                         :card         {:bg :white}
                                         :card-shading :black-transparent
                                         :shading-text :white
                                         :link         :brand-2
                                         :menu         {:dropdown {:bg :white}
                                                        :item     {:hover :grey-40}}}
                      :landing-page     {:report-container {:border :border-color}}
                      :report-container {:border :border-color}
                      :outer-container  {:border :border-color}
                      :report           {:toolbar {:border :light-grey}}
                      :section          {:border :background
                                         :title  {:default :grey-80}}
                      :card             {:body {:link   {:hover   :brand-2
                                                         :default :grey-80}
                                                :bg     :white
                                                :border :light-grey}
                                         :head {:title :grey-80}}
                      :table            {:cell   {:strong :gray-80}
                                         :border :light-grey}}
   :lp-editor        {:page             {:background     :white
                                         :data-watermark :background}
                      :header           {:background :transparent}
                      :step             {:icon {:done    :success
                                                :default :grey-50}}
                      :checkbox         {:checked :brand-2}
                      :sidebar-nav-link {:default :brand-2
                                         :hover   :base-brand-2}
                      :upload           {:default      :grey-20
                                         :progress     :grey-15
                                         :uploading    :brand-2
                                         :error        :danger
                                         :processing   :warning
                                         :complete     :brand-2
                                         :progress-bar {:text       :white
                                                        :background :base-brand-3}}
                      }})

(def edge-sizes
  "Margins and paddings"
  {})

(def font-weights
  {})

(def text-sizes
  "text-size/size corresponds to CSS `font-size`
  text-size/height corresponds to CSS `line-height`"
  {})

(def font-families
  {:palatino "Palatino LT Pro"
   :gothic   "News Gothic MT"})

(def theme
  {:border-radiuses border-radiuses
   :border-widths   border-widths
   :colors          colors
   :edge-sizes      edge-sizes
   :font-weights    font-weights
   :palette         palette
   :text-sizes      text-sizes
   :font-families   font-families})
